// Kiosk question bank — 10 qualification questions per role.
// Branched based on the role selected at Screen 2.
//
// Each question:
//   id          : stable identifier sent to backend in the responses array
//   text        : displayed question
//   answer_type : "single" | "multi" | "text"
//   options     : array of strings (omit for text)
//   skippable   : optional, allows the user to skip (text-only typically)

const READER_QUESTIONS = [
  { id: "rd_format", text: "Print, audiobook, or both?", answer_type: "single",
    options: ["Print only", "Audiobook only", "Both", "Neither yet"] },
  { id: "rd_hours", text: "How many hours per week do you listen to audiobooks?", answer_type: "single",
    options: ["None", "1–3", "4–7", "8+"] },
  { id: "rd_source", text: "Where do you get audiobooks today?", answer_type: "single",
    options: ["Audible", "Spotify", "Library app", "Other", "Don't listen yet"] },
  { id: "rd_spend", text: "About how much do you spend on books each month?", answer_type: "single",
    options: ["Under $10", "$10–25", "$25–50", "$50+"] },
  { id: "rd_genres", text: "Which genres do you enjoy? (Select all that apply)", answer_type: "multi",
    options: ["Fiction", "Non-fiction", "Mystery & Thriller", "Romance", "Sci-Fi & Fantasy", "Biography", "Self-help", "Business"] },
  { id: "rd_device", text: "What's your primary listening device?", answer_type: "single",
    options: ["Phone", "Tablet", "Smart speaker", "Computer", "Car"] },
  { id: "rd_curiosity", text: "Have you ever wished you could ask a question about a book while reading or listening?", answer_type: "single",
    options: ["Yes", "Sometimes", "No"] },
  { id: "rd_ai_interest", text: "How interested are you in an AI assistant that answers questions about the book in real time?", answer_type: "single",
    options: ["Very", "Somewhat", "Not yet sure"] },
  { id: "rd_billing", text: "Subscription or pay-per-engagement?", answer_type: "single",
    options: ["Subscription", "Pay as I go", "Either works"] },
  { id: "rd_missing", text: "What's missing from audiobooks today?", answer_type: "text", skippable: true },
];

const AUTHOR_QUESTIONS = [
  { id: "au_count", text: "How many books have you published?", answer_type: "single",
    options: ["0", "1–3", "4–10", "10+"] },
  { id: "au_audio", text: "Do your books have audiobook versions?", answer_type: "single",
    options: ["All of them", "Some", "None — wanted to", "Tried and gave up"] },
  { id: "au_frustration", text: "What's your biggest frustration with audiobook production?", answer_type: "single",
    options: ["Cost", "Time", "Narration quality", "Distribution", "Didn't know where to start"] },
  { id: "au_budget", text: "What have you spent or budgeted per audiobook?", answer_type: "single",
    options: ["Under $500", "$500–2K", "$2K–5K", "$5K+", "Haven't spent yet"] },
  { id: "au_ai_tried", text: "Have you tried AI narration before?", answer_type: "single",
    options: ["Yes — liked it", "Yes — disappointed", "No — open to it", "No — skeptical"] },
  { id: "au_blocker", text: "What's stopped you from making more audiobooks?", answer_type: "single",
    options: ["Cost", "Tech complexity", "Distribution", "Quality concerns", "Time"] },
  { id: "au_distribution", text: "Where do you distribute your books today?", answer_type: "single",
    options: ["KDP", "IngramSpark", "Draft2Digital", "Direct", "Multiple"] },
  { id: "au_genres", text: "Which genres do you write in? (Select all that apply)", answer_type: "multi",
    options: ["Fiction", "Non-fiction", "Mystery & Thriller", "Romance", "Sci-Fi & Fantasy", "Biography", "Self-help", "Business", "Children's"] },
  { id: "au_assistant", text: "How important is an interactive AI assistant for your readers?", answer_type: "single",
    options: ["Critical", "Nice to have", "Not important"] },
  { id: "au_trial", text: "Would you trial NewAudia with one of your titles?", answer_type: "single",
    options: ["Yes", "Maybe — tell me more", "Not yet"] },
];

// Multiple = mix of 5 reader + 5 author questions in the brief order
const MULTIPLE_QUESTIONS = [
  READER_QUESTIONS.find(q => q.id === "rd_format"),
  READER_QUESTIONS.find(q => q.id === "rd_hours"),
  READER_QUESTIONS.find(q => q.id === "rd_genres"),
  READER_QUESTIONS.find(q => q.id === "rd_curiosity"),
  READER_QUESTIONS.find(q => q.id === "rd_ai_interest"),
  AUTHOR_QUESTIONS.find(q => q.id === "au_count"),
  AUTHOR_QUESTIONS.find(q => q.id === "au_audio"),
  AUTHOR_QUESTIONS.find(q => q.id === "au_frustration"),
  AUTHOR_QUESTIONS.find(q => q.id === "au_ai_tried"),
  AUTHOR_QUESTIONS.find(q => q.id === "au_trial"),
];

export const ROLE_OPTIONS = [
  { value: "reader", label: "Reader / Listener" },
  { value: "author_self_publisher", label: "Author or Self-Publisher" },
  { value: "publisher", label: "Publisher" },
  { value: "multiple", label: "Multiple of the above" },
];

export function getQuestionsForRole(role) {
  switch (role) {
    case "reader": return READER_QUESTIONS;
    case "author_self_publisher": return AUTHOR_QUESTIONS;
    case "publisher": return AUTHOR_QUESTIONS; // Publisher path = same as author per brief
    case "multiple": return MULTIPLE_QUESTIONS;
    default: return [];
  }
}
